<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import euImage from "../../../core/assets/icons/EU_3.png?webp&w=800&imagetools";
	import projectImage from "../assets/eu/eu-projekt.jpg?webp&w=800&imagetools";
	import project2Image from "../assets/eu/plakat_eu.jpg?webp&w=800&imagetools";
	import Formatted from "../components/common/Formatted.svelte";
	import Media from "../components/common/Media.svelte";
	import Breadcrumbs from "../components/layout/Breadcrumbs.svelte";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./EuProjektDetail.translations.json" with { type: "json" };
	import type { EuProjektDetailProps } from "./EuProjektDetailProps.js";

	const { projectId }: EuProjektDetailProps = $props();
	const translate = getTranslate(translations);

	const { breadcrumbs, title } = getGlobalTemplateProps();

	const projectKey = `project${projectId}` as const;
	const partnerKey = `${projectKey}Partner` as keyof typeof translations;
	const registrationKey = `${projectKey}RegistrationNumber` as keyof typeof translations;
	const importanceKey = `${projectKey}Importance` as keyof typeof translations;
	const currentProjectImage = projectId === "1" ? projectImage : projectId === "2" ? project2Image : euImage;
</script>

<Layout>
	<Breadcrumbs {breadcrumbs} currentPageTitle={title ?? ""} />
	<section class="container-center pb-8 md:pb-12 lg:pb-16">
		<h1 class="text-zms-blue font-semibold mb-6">
			<Formatted text={translate(`${projectKey}Title` as keyof typeof translations)} />
		</h1>

		<p class="text-optical-black text-base md:text-lg mb-8">
			<Formatted text={translate(`${projectKey}Description` as keyof typeof translations)} />
		</p>

		{#if translate(registrationKey) !== registrationKey}
			<p class="text-optical-black text-sm md:text-base mb-8">
				<strong><Formatted text={translate("registrationNumber")} />:</strong>
				<Formatted text={translate(registrationKey)} />
			</p>
		{/if}

		{#if translate(partnerKey) !== partnerKey}
			<div class="overflow-x-auto mb-12">
				<table class="w-full text-left border-collapse">
					<tbody>
						<tr class="border-b border-gray-200">
							<td class="py-4 pr-8 font-semibold text-optical-black align-top whitespace-nowrap">
								<Formatted text={translate("programName")} />:
							</td>
							<td class="py-4 text-optical-black">
								<Formatted text={translate(`${projectKey}ProgramName` as keyof typeof translations)} />
							</td>
						</tr>
						<tr class="border-b border-gray-200">
							<td class="py-4 pr-8 font-semibold text-optical-black align-top whitespace-nowrap">
								<Formatted text={translate("programSupportName")} />:
							</td>
							<td class="py-4 text-optical-black">
								<Formatted text={translate(`${projectKey}ProgramSupport` as keyof typeof translations)} />
							</td>
						</tr>
						<tr class="border-b border-gray-200">
							<td class="py-4 pr-8 font-semibold text-optical-black align-top whitespace-nowrap">
								<Formatted text={translate("applicantName")} />:
							</td>
							<td class="py-4 text-optical-black">
								<Formatted text={translate(`${projectKey}Applicant` as keyof typeof translations)} />
							</td>
						</tr>
						{#if translate(partnerKey) !== partnerKey}
							<tr class="border-b border-gray-200">
								<td class="py-4 pr-8 font-semibold text-optical-black align-top whitespace-nowrap">
									<Formatted text={translate("projectPartnerName")} />:
								</td>
								<td class="py-4 text-optical-black">
									<Formatted text={translate(partnerKey)} />
								</td>
							</tr>
						{/if}
						<tr class="border-b border-gray-200">
							<td class="py-4 pr-8 font-semibold text-optical-black align-top whitespace-nowrap">
								<Formatted text={translate("realizationPeriod")} />:
							</td>
							<td class="py-4 text-optical-black">
								<Formatted text={translate(`${projectKey}Period` as keyof typeof translations)} />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		{/if}

		{#if projectId !== "3"}
			<div class="mb-12">
				<Media
					class="w-full h-auto max-w-2xl"
					source={{ src: currentProjectImage, type: "image/webp" }}
					width={800}
					height={0}
					alt={translate(`${projectKey}Title` as keyof typeof translations)}
					lightbox="eu-projekt"
					lightboxWidth={1200}
				/>
			</div>
		{/if}

		{#if translate(importanceKey) !== importanceKey}
			<div class="mb-8">
				<h2 class="text-zms-blue font-semibold text-xl md:text-2xl mb-4">
					<Formatted text={translate("projectImportance")} />
				</h2>
				<p class="text-optical-black text-base md:text-lg">
					<Formatted text={translate(importanceKey)} />
				</p>
			</div>
		{/if}

		{#if projectId !== "3"}
			<div class="flex flex-col items-start gap-6 pt-8 border-t border-gray-200">
				<p class="text-optical-black text-sm mb-6">
					<Formatted text={translate("fundedByEu")} />
				</p>
			</div>
		{/if}
	</section>
</Layout>
